export default {
  set (state, marketRecords) {
    state.marketRecords = marketRecords
  }
}
